import React, { useEffect, useState } from 'react';
import { Text, Tag } from '../../Reusable/Text';
import { Checkbox, Select, Tooltip } from 'antd'
import { LabeledInput } from '../../Reusable/Input';
import { Button, TextButton } from '../../Reusable/Button'
import Banner from '../../Reusable/Banner'
import { Image } from '../../Reusable/Image'
import { ErrorAlert } from '../../Reusable/Alert'
import { FromAccountOption, PaymentMethodOption } from '../../Reusable/Option'
import moment from 'moment'
import { toCurrency, getBPAccountsWithAccess, toNumberStr } from '../../../Utils/util'
import { apiPOSTReq } from '../../../Utils/api'
import environment from '../../../environment'
import { Flex, FlexColumn, Container, Card, CardContainer } from '../../Reusable/Container';
import Arrow from '../../../Images/arrow-right.png'
import Profile from '../../../Images/merchant-profile.svg'
import Phone from '../../../Images/merchant-phone.svg'
import Email from '../../../Images/merchant-email.svg'
import Check from '../../../Images/check-green.svg'
import Info from '../../../Images/info.png'
import AionIcon from '../../../Images/aion-bank-icon.png'
import AionBankIcon from '../../../Images/pay-by-bank-aion.svg'
import BankIcon from '../../../Images/pay-by-bank-bank.svg'
import BankIconSelected from '../../../Images/pay-by-bank-bank-selected.svg'
import BankConnect from './BankConnect';

const { Option } = Select


const PaymentOptions = ({ width, onLogin, aionAccountsLoading, accounts, pay, errorField, errorMessage, payLoading, plaid, refNum, title, bottomCTA, businessName }) => {
    const [loggedIntoAion, setLoggedIntoAion] = useState(false);
    const [payByBank, setPayByBank] = useState(true);
    const [payByAion, setPayByAion] = useState(false);
    const [routingNumber, setRoutingNumber] = useState();
    const [accountNumber, setAccountNumber] = useState();
    const [accountType, setAccountType] = useState();
    const [bankName, setBankName] = useState();
    const [confirmAccountNumber, setConfirmAccountNumber] = useState();
    const [fromAccount, setFromAccount] = useState();
    const [loading, setLoading] = useState();
    const [hideManualInput, setHideManualInput] = useState(plaid);
    const [connectCTALoading, setConnectCTALoading] = useState(false);
    const [accountDetails, setAccountDetails] = useState();
    const [forceManual, setForceManual] = useState();

    useEffect(() => {
        if (accountDetails && (!accountDetails?.routingNumber || !accountDetails?.accountNumber)) {
            setForceManual(true)
            setRoutingNumber(accountDetails?.routingNumber)
            setAccountNumber(accountDetails?.accountNumber)
            setBankName(accountDetails?.bankName)
        }
    }, [accountDetails]);

    const handleBankChange = (e) => {
        setPayByBank(e.target.checked);
        setPayByAion(false);
    };

    const handleAionChange = (e) => {
        setPayByAion(e.target.checked);
        setPayByBank(false);
    };

    const handleSelectAccount = (value, option) => {
        var Accounts = getBPAccountsWithAccess("Payments", { permType: "manage", getActiveAccounts: true })
        var account = Accounts.find(a => a.accountId === value)

        console.log('CustomerPayment handleSelectAccount', account)

        setFromAccount(account)
        // this.getFees({ ...(this.state.paymentMethod || {}), fromAccount: account || {} })
    }

    var options = []
    var filteredAccounts = accounts?.filter(item => { return (!['ACCOUNTS_RECEIVABLE', 'Transitional', 'CHECKINGYIELD'].includes(item.accountType)) }) || []
    filteredAccounts.forEach(account => {
        options.push(
            <Option key={account.accountId} value={account.accountId} style={{ backgroundColor: "transparent" }}>
                <FromAccountOption account={account} />
            </Option>)
    })

    const loggedIn = (accounts && accounts.length > 0)

    return (
        <FlexColumn start left gap="24px" style={{ width: width }} fullWidth={!width}>
            <Text size="16px" heading weight="500">{title || "PAYMENT OPTIONS"}</Text>

            <FlexColumn left start gap="24px" fullWidth>
                <CardContainer className="radio-table" fullWidth>
                    <Flex between style={{ cursor: 'pointer' }} onClick={() => {
                        setPayByBank(!payByBank);
                        setPayByAion(false);
                    }}>
                        <Flex>
                            <Checkbox checked={payByBank} onChange={handleBankChange} />
                            <FlexColumn style={{ margin: '0 0 0 8px' }}>
                                <Text size="16px" weight={payByBank ? '700' : '400'}>Pay by Bank Transfer</Text>
                                <Text lightText>Enter your bank details and authorize Aion to pull funds</Text>
                            </FlexColumn>
                        </Flex>
                        <Flex>
                            <Image width='48px' height='48px' src={payByBank ? BankIconSelected : BankIcon} />
                        </Flex>
                    </Flex>

                    {
                        payByBank &&
                        <FlexColumn start left>
                            <div style={{ width: '100%', height: 1, background: '#E6E6EC', margin: '24px 0' }}></div>

                            {
                                (plaid && (hideManualInput && !forceManual)) &&
                                <FlexColumn start between gap="30px">
                                    <BankConnect
                                        plusIcon
                                        onSuccess={() => setLoading(true)}
                                        onComplete={(bankInfo) => { }}
                                        connectOnly
                                        minimumDeposit
                                        connectCTA={<Button text="Connect bank account" loading={connectCTALoading} />}
                                        refNum={refNum}
                                        setConnectCTALoading={setConnectCTALoading}
                                        accountDetails={accountDetails}
                                        setAccountDetails={setAccountDetails}
                                        onBack={() => setAccountDetails(null)}
                                        backCTAText="Choose different account"
                                    />

                                    {
                                        !accountDetails && <TextButton
                                            color='#8181A0'
                                            weight='400'
                                            text="Enter bank details manually"
                                            onClick={() => setHideManualInput(false)}
                                            underline
                                            size='12px'
                                        />
                                    }
                                </FlexColumn>
                            }

                            {
                                forceManual &&
                                <Banner icon={<Image src={Info} />} style={{ marginBottom: 24, width: '100%' }} message="Could not connect your bank account. Please enter details manually" />
                            }

                            {
                                (!hideManualInput || forceManual) &&
                                <Flex wrap gap='24px' start>
                                    <LabeledInput
                                        label="ACH Routing Number"
                                        id="routingNumber"
                                        key="routingNumber"
                                        placeholder="Enter a 9 digit routing number"
                                        value={routingNumber && routingNumber}
                                        maxLength={9}
                                        onChange={(event) => setRoutingNumber(event.target.value)}
                                        error={errorField === "routingNumber"}
                                        errorMessage={errorMessage}
                                        tooltip='Your bank may use different routing numbers for ACH vs. other transfers. Make sure you enter the ACH routing number specifically to avoid any confusion or mistakes in the transfer process.'
                                        nomargin
                                    // width={width && '276px'}
                                    />

                                    <LabeledInput
                                        label="Account Number"
                                        placeholder="Eg: 112454696"
                                        value={accountNumber && accountNumber}
                                        maxLength={17}
                                        onChange={(event) => setAccountNumber(event.target.value)}
                                        error={errorField === "accountNumber"}
                                        errorMessage={errorMessage}
                                        nomargin
                                        width={width && '276px'}
                                    />

                                    <LabeledInput
                                        label="Confirm Account Number"
                                        placeholder="Confirm your account #"
                                        value={confirmAccountNumber && confirmAccountNumber}
                                        maxLength={17}
                                        onChange={(event) => setConfirmAccountNumber(event.target.value)}
                                        error={errorField === "confirmAccountNumber"}
                                        errorMessage={errorMessage}
                                        nomargin
                                        width={width && '276px'}
                                    />

                                    <LabeledInput
                                        label="Bank Name"
                                        id="bankName"
                                        key="bankName"
                                        placeholder="Enter Bank Name"
                                        value={bankName && bankName}
                                        onChange={(event) => setBankName(event.target.value)}
                                        error={errorField === "bankName"}
                                        errorMessage={`Bank Name is required`}
                                        width={width && '276px'}
                                        nomargin
                                    />

                                    <LabeledInput
                                        label='Account Type'
                                        type='switch'
                                        switchNames={['Checking', 'Savings']}
                                        onChange={(value) => setAccountType(value)}
                                        value={accountType}
                                        error={errorField === "accountType"}
                                        errorMessage={errorMessage}
                                        nomargin
                                        width={width && '276px'}
                                    />
                                </Flex>
                            }

                            {
                                (plaid && (!hideManualInput || forceManual)) &&
                                <TextButton
                                    // color='#8181A0'
                                    weight='400'
                                    text="Connect your bank account"
                                    onClick={() => {
                                        setForceManual(false)
                                        setHideManualInput(true)
                                    }}
                                    underline
                                    size='12px'
                                    margin="12px 0 0"
                                />
                            }

                            {
                                ((!hideManualInput || forceManual) && !bottomCTA) && <>
                                    <Flex start fullWidth style={{ margin: '24px 0 16px' }} centerHorizontally gap='4px' wrap>
                                        <Text>By clicking on “Authorize and Pay”, Payer agrees to Aion’s <a target="_blank" href="https://www.aionfi.com/legal">Legal Terms & Conditions</a>; Payer agrees that ACH transactions authorized by Payer comply with all applicable laws.</Text>
                                    </Flex>

                                    <Button
                                        text='Authorize and Pay'
                                        loading={payLoading}
                                        solid
                                        onClick={() => pay(payByAion, {
                                            accountName: null,
                                            accountNumber,
                                            confirmAccountNumber,
                                            routingNumber,
                                            accountSubType: accountType,
                                            bankName,
                                        })}
                                    />
                                </>
                            }

                            {
                                ((hideManualInput && !forceManual) && accountDetails && !bottomCTA) &&
                                <>
                                    <Flex start fullWidth style={{ margin: '24px 0 16px' }} centerHorizontally gap='4px' wrap>
                                        <Text>By clicking on “Authorize and Pay”, Payer agrees to Aion’s <a target="_blank" href="https://www.aionfi.com/legal">Legal Terms & Conditions</a>; Payer agrees that ACH transactions authorized by Payer comply with all applicable laws.</Text>
                                    </Flex>
                                    <Button
                                        text='Authorize and Pay'
                                        loading={payLoading}
                                        solid
                                        onClick={() => {
                                            pay(payByAion, {
                                                accountName: accountDetails?.accountName,
                                                accountNumber: accountDetails?.accountNumber,
                                                confirmAccountNumber: accountDetails?.accountNumber,
                                                routingNumber: accountDetails?.routingNumber,
                                                accountSubType: accountDetails?.accountType,
                                                bankName: accountDetails?.bankName,
                                                logoUrl: accountDetails?.bankLogoUrl,
                                            })
                                        }}
                                    />
                                </>
                            }
                        </FlexColumn>
                    }
                </CardContainer>

                <CardContainer className="radio-table" fullWidth>
                    <Flex between style={{ cursor: 'pointer' }} onClick={() => {
                        setPayByAion(!payByAion);
                        setPayByBank(false);
                    }}>
                        <Flex start>
                            <Checkbox checked={payByAion} onChange={handleAionChange} />
                            <FlexColumn style={{ margin: '0 0 0 8px' }}>
                                <Text size="16px" weight={payByAion ? '700' : '400'}>Aion Pay</Text>
                                <Text lightText>Have an Aion account? Pay via Aion Pay at no extra charge</Text>
                            </FlexColumn>
                        </Flex>
                        <Flex>
                            <Image width='48px' height='48px' src={AionBankIcon} />
                        </Flex>
                    </Flex>

                    {
                        payByAion &&
                        <FlexColumn start left fullWidth>
                            <div style={{ width: '100%', height: 1, background: '#E6E6EC', margin: '24px 0' }}></div>

                            {
                                loggedIn ?
                                    <>
                                        <Banner
                                            style={{ marginBottom: 10, width: '100%' }}
                                            borderColor='#6DB58B'
                                            background='#F0F8F3'
                                            color='#6DB58B'
                                            message="Logged in successfully via Aion"
                                            icon={<Image src={Check} />}
                                        />

                                        <LabeledInput
                                            label="Select Aion Account"
                                            type="select"
                                            id="fromAccount"
                                            // width='276px'
                                            placeholder="Select account"
                                            value={fromAccount && <Flex between centerHorizontally style={{ height: 30 }}>
                                                <Text><img width='16px' height='16px' src={AionIcon} style={{ marginRight: 8, marginBottom: 2 }} />{`${(fromAccount.nickName || `Business ${fromAccount.accountSubType}`)} • ${fromAccount.mask}`}</Text>
                                                <Text size='14px' lightText style={{ marginLeft: 8 }}>${toCurrency(fromAccount.availableBalance)}</Text>
                                            </Flex>}
                                            onChange={handleSelectAccount}
                                            // noAsterisk
                                            error={errorField === "fromAccount"}
                                            errorMessage={errorMessage}
                                        >
                                            {options}
                                        </LabeledInput>
                                    </>
                                    :
                                    <>
                                        <FlexColumn fullWidth center gap='16px'>
                                            <Text>Login to Aion to retrieve your accounts</Text>
                                            <Button loading={aionAccountsLoading} text='Login' width='244px' onClick={onLogin} />
                                        </FlexColumn>

                                        <Flex center fullWidth style={{ margin: '24px 0' }}>
                                            <span style={{ flex: 1, borderBottom: '1px solid #E6E6EC' }}></span>
                                            <Text color='#8181A0' margin='0 16px'>OR</Text>
                                            <span style={{ flex: 1, borderBottom: '1px solid #E6E6EC' }}></span>
                                        </Flex>

                                        <Flex wrap gap='24px' start fullWidth style={{ marginBottom: 24 }}>
                                            <LabeledInput
                                                label="Account Number"
                                                placeholder="Eg: 112454696"
                                                value={accountNumber && accountNumber}
                                                maxLength={17}
                                                onChange={(event) => setAccountNumber(event.target.value)}
                                                error={errorField === "accountNumber"}
                                                errorMessage={errorMessage}
                                                nomargin
                                                width={width && '276px'}
                                            />

                                            <LabeledInput
                                                label="Confirm Account Number"
                                                placeholder="Confirm your account #"
                                                value={confirmAccountNumber && confirmAccountNumber}
                                                maxLength={17}
                                                onChange={(event) => setConfirmAccountNumber(event.target.value)}
                                                error={errorField === "confirmAccountNumber"}
                                                errorMessage={errorMessage}
                                                nomargin
                                                width={width && '276px'}
                                            />
                                        </Flex>


                                        {/* <LabeledInput
                                            label='Account Type'
                                            type='switch'
                                            switchNames={['Checking', 'Savings']}
                                            onChange={(value) => setAccountType(value)}
                                            value={accountType}
                                            error={errorField === "accountType"}
                                            errorMessage={errorMessage}
                                            nomargin
                                            width={width && '276px'}
                                        /> */}
                                    </>
                            }

                            {
                                !bottomCTA &&
                                <>
                                    <Flex start fullWidth style={{ margin: '24px 0 16px' }} centerHorizontally gap='4px' wrap>
                                        <Text>By clicking on “Authorize and Pay”, Payer agrees to Aion’s <a target="_blank" href="https://www.aionfi.com/legal">Legal Terms & Conditions</a>; Payer agrees that ACH transactions authorized by Payer comply with all applicable laws.</Text>
                                    </Flex>

                                    <Button
                                        loading={payLoading}
                                        text='Authorize and Pay'
                                        solid
                                        onClick={() => pay(payByAion, loggedIn ? fromAccount : { loggedIn: false, accountName: null, accountNumber, confirmAccountNumber, routingNumber: "021214891", accountSubType: "Checking", bankName: "Aion" })}
                                    />
                                </>
                            }
                        </FlexColumn>
                    }
                </CardContainer>

                {
                    (bottomCTA && (!hideManualInput || forceManual) && !payByAion) &&
                    <>
                        <FlexColumn start gap="16px">
                            <Text>By confirming this payment, you allow {businessName} to charge you for this payment and future payments in accordance with their terms.</Text>
                            <Text>By clicking on "Authorize and Pay", you agree to Aion’s <a target="_blank" href="https://www.aionfi.com/legal">Legal Terms & Conditions</a></Text>
                        </FlexColumn>
                        <Button
                            text='Authorize and Pay'
                            loading={payLoading}
                            solid
                            onClick={() => pay(payByAion, {
                                accountName: null,
                                accountNumber,
                                confirmAccountNumber,
                                routingNumber,
                                accountSubType: accountType,
                                bankName,
                            })}
                        />
                    </>
                }

                {
                    (bottomCTA && (hideManualInput && !forceManual) && accountDetails && !payByAion) &&
                    <>
                        <FlexColumn start gap="16px">
                            <Text>By confirming this payment, you allow {businessName} to charge you for this payment and future payments in accordance with their terms.</Text>
                            <Text>By clicking on "Authorize and Pay", you agree to Aion’s <a target="_blank" href="https://www.aionfi.com/legal">Legal Terms & Conditions</a></Text>
                        </FlexColumn>
                        <Button
                            text='Authorize and Pay'
                            loading={payLoading}
                            solid
                            onClick={() => {
                                pay(payByAion, {
                                    accountName: accountDetails?.accountName,
                                    accountNumber: accountDetails?.accountNumber,
                                    confirmAccountNumber: accountDetails?.accountNumber,
                                    routingNumber: accountDetails?.routingNumber,
                                    accountSubType: accountDetails?.accountType,
                                    bankName: accountDetails?.bankName,
                                    logoUrl: accountDetails?.bankLogoUrl,
                                })
                            }}
                        />
                    </>
                }

                {
                    (bottomCTA && payByAion) &&
                    <>
                        <FlexColumn start gap="16px">
                            <Text>By confirming this payment, you allow {businessName} to charge you for this payment and future payments in accordance with their terms.</Text>
                            <Text>By clicking on "Authorize and Pay", you agree to Aion’s <a target="_blank" href="https://www.aionfi.com/legal">Legal Terms & Conditions</a></Text>
                        </FlexColumn>
                        <Button
                            loading={payLoading}
                            text='Authorize and Pay'
                            solid
                            onClick={() => pay(payByAion, loggedIn ? fromAccount : { loggedIn: false, accountName: null, accountNumber, confirmAccountNumber, routingNumber: "021214891", accountSubType: "Checking", bankName: "Aion" })}
                        />
                    </>
                }
            </FlexColumn>
        </FlexColumn>
    );
};

export default PaymentOptions;

